
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/georgia",
      function () {
        return require("private-next-pages/medical-card/georgia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/georgia"])
      });
    }
  